module.exports = __webpack_public_path__ + "media/images/icons/icon-mentorship-80b49827135cb0505062562fb0518a31.svg";